import type { Vault } from '@/types/vault'

export type ProtocolDisplayInfo = Pick<Vault['protocol'], 'name' | 'displayName'>

export function getProtocolDisplayName(protocol: ProtocolDisplayInfo) {
  return protocol.displayName || protocol.name
}
